'use client';

import { usePathname } from 'next/navigation';
import { internalPathFromBrowserPath } from 'lib/region/internalPath';

/**
 * Strips the region-locale prefix (/us/, /de-en/, /global/) from a browser path,
 * yielding the internal route path the proxy rewrites to.
 */
export function stripRegionPrefix(pathname: string): string {
  return internalPathFromBrowserPath(pathname);
}

/**
 * Browser pathname without the region prefix — the stable equivalent of the
 * Pages Router's `router.pathname` for prefix-insensitive route checks.
 * Works under both routers (next/navigation hooks are pages-compatible).
 *
 * Unlike `router.pathname`, dynamic segments are actual values (/order/UH123),
 * not templates (/order/[orderNo]) — use startsWith/section checks, not
 * template equality.
 */
export function useInternalPathname(): string {
  const pathname = usePathname() ?? '/';
  return stripRegionPrefix(pathname);
}
